import dashboardIcon from './dashboard.svg';
import userIcon from "./user-man.svg";
import referenceIcon from "./reference-mn.svg";
import cpIcon from "./cp-mn.svg";
import parentLabelIcon from "./parent-label.svg";
import labelsIcon from "./labels.svg";
import labelServiceIcon from "./ser-label.svg";
import reportIcon from "./report.svg";
import serviceReportIcon from "./ser-reports.svg";
import userProfile from './default-welcm-img.png'
import downArrow from './drparrow.svg'
import burgerIcon from './burger-icon.svg'
import PaymentIcon from './pngwing.png';
import bgMain from './bigimage.svg';
import finance from './undraw_finance_re_gnv2.svg'
import rockLogo from './rockvilleLogo.svg'

const menuIcon = burgerIcon;

export {
  dashboardIcon,
  userIcon,
  referenceIcon,
  cpIcon,
  parentLabelIcon,
  labelsIcon,
  labelServiceIcon,
  reportIcon,
  serviceReportIcon,
  menuIcon,
  userProfile,
  downArrow,PaymentIcon,bgMain,finance,rockLogo
}
